import type { ICellRendererParams } from 'ag-grid-community';
import { SensitivityContainer } from 'components/Blotters/sensitivity/sensitivity';
import { useShouldReloadSensitivityDataOnMount } from 'components/Blotters/sensitivity/useShouldReloadSensitivityDataOnMount';
import { GenericErrorBoundary } from 'components/common-form/builder/form/GenericErrorBoundary';
import { IBlotterTradeItem } from 'models/IBlotterItem';

const rowSnapshotByQuoteId = new Map<string, IBlotterTradeItem>();

export function SensitivityDetailCellRenderer({ data, node }: ICellRendererParams<IBlotterTradeItem>) {
  const shouldRefresh = useShouldReloadSensitivityDataOnMount(data, rowSnapshotByQuoteId);

  return (
    <GenericErrorBoundary context={{ nodeId: node.id ?? '' }}>
      <SensitivityContainer
        className="w-100"
        paddingLeft={65}
        referenceQuoteId={data?.quoteId!}
        shouldRefresh={shouldRefresh}
      />
    </GenericErrorBoundary>
  );
}
